<template>
  <div>
    <v-timeline align-top dense>
      <v-timeline-item
        v-for="(item, index) in visibleScheduleDates"
        :key="index"
        color="blue"
        small
        :icon="generateIcon(item)"
        :class="{ disabled: item.excluded }"
      >
        <div class="d-flex flex-column flex-md-row">
          <div
            class="d-flex flex-row flex-md-column"
            style="white-space: nowrap; min-width: 100px"
          >
            <strong>
              <span>
                {{ item.schedule.startTime | formatTime }}
              </span>
            </strong>
            <div class="text-caption mx-2 mx-md-0">
              {{ item.schedule.endTime | formatTime }}
            </div>
            <div class="text-caption">
              {{ item.date | formatShortDate }}
            </div>
          </div>
          <div class="d-flex flex-grow-1" style="width: 100%">
            <div
              class="
                flex-column
                mx-0 mx-md-4
                mt-2 mt-md-0
                flex-grow-1
                justify-start
                text-caption
              "
            >
              <h4>{{ item.schedule.location }}</h4>
              <div>{{ getProgramName(item.schedule.programId) }}</div>
              <div style="white-space: nowrap">
                {{ getAssignmentInfo(item.schedule) }}
              </div>
              <p v-if="item.schedule.recurring">
                <span v-if="item.schedule.recurringEndDate">
                  Ends on
                  {{ item.schedule.recurringEndDate | formatDate }}
                </span>
                <span v-else> Recurring with no end date </span>
              </p>
            </div>

            <div class="text-end">
              <v-btn
                v-if="!item.excluded"
                @click="editSchedule(item.date, item.schedule)"
                icon
                color="primary"
              >
                <v-icon> mdi-pencil </v-icon>
              </v-btn>
              <v-btn
                v-else
                @click="undoCancellation(item.schedule.id, item.date)"
                icon
                color="primary"
              >
                <v-icon class="enabled-icon"> mdi-undo </v-icon>
              </v-btn>
            </div>
          </div>
        </div>
      </v-timeline-item>
    </v-timeline>
    <div v-if="hasMoreSchedules" class="text-center mt-3">
      <v-btn @click="loadMore" color="primary">Load More</v-btn>
    </div>
  </div>
</template>

<script>
import {
  generateActiveDates,
  generatePastDates,
} from "@/utils/scheduling/scheduleUtils.js";
import moment from 'moment';

export default {
  props: {
    value: {
      type: Array,
      required: true,
    },
    scheduleExclusionDates: {
      type: Array,
      required: false,
    },
    showPastDates: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideCancelled: {
      type: Boolean,
      required: false,
      default: true,
    },
    getProgramName: {
      type: Function,
      required: true,
    },
    getAssignmentInfo: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    scheduleDates: [],
    monthsRange: 1,
  }),
  watch: {
    value() {
      this.reloadDates();
    },
    scheduleExclusionDates(){
      this.reloadDates();
    },
    hideCancelled(newVal, oldVal) {
      console.log(`hideCancelled changed from ${oldVal} to ${newVal}`);
    },
  },
  computed: {
    visibleScheduleDates() {
      if (this.hideCancelled) {
        return this.scheduleDates.filter((schedule) => !schedule.excluded);
      } else {
        return this.scheduleDates;
      }
    },
    hasMoreSchedules() {
      // Find the maximum and minimum dates in the schedules
      let maxDate = null;
      let minDate = null;
      for (let schedule of this.value) {
        const startDate = moment(schedule.startDate);
        const endDate = schedule.recurringEndDate
          ? moment(schedule.recurringEndDate)
          : moment().add(100, "years");
        if (!maxDate || endDate.isAfter(maxDate)) {
          maxDate = endDate;
        }
        if (!minDate || startDate.isBefore(minDate)) {
          minDate = startDate;
        }
      }

      // Compare with the current range
      if (this.showPastDates) {
        return minDate.isSameOrBefore(
          moment().subtract(this.monthsRange, "month").startOf("day")
        );
      } else {
        return maxDate.isSameOrAfter(moment().add(this.monthsRange, "month"));
      }
    },
  },
  mounted() {
    this.reloadDates();
  },
  methods: {
    loadMore() {
      this.monthsRange += 1; // Increase the range by one month
      this.reloadDates(); // Reload the dates
    },
    undoCancellation(scheduleId, date) {
      this.$emit("on-undo-cancellation", scheduleId, date);
    },
    reloadDates() {
      if (this.showPastDates) {
        this.scheduleDates = generatePastDates(
          this.value,
          this.scheduleExclusionDates,
          this.monthsRange
        );
      } else {
        this.scheduleDates = generateActiveDates(
          this.value,
          this.scheduleExclusionDates,
          this.monthsRange
        );
      }
    },
    editSchedule(date, schedule) {
      this.$emit("on-edit", date, schedule);
    },
    undeCancellation(scheduleId, date) {
      this.$emit("on-undo-cancellation", scheduleId, date);
    },
    generateIcon(item) {
      if (item.excluded) {
        return "mdi-cancel";
      } else if (item && item.schedule && item.schedule.recurring) {
        return "mdi-repeat";
      } else {
        return "";
      }
    },
  },
};
</script>
<style scoped>
.disabled {
  opacity: 0.6;
  pointer-events: none;
}

.enabled-icon {
  opacity: 1 !important;
  pointer-events: auto !important;
}
</style>